import { render } from "./FaqManageListForm.vue?vue&type=template&id=034f28f8&lang=true"
import script from "./FaqManageListForm.vue?vue&type=script&lang=js"
export * from "./FaqManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__